import { render, staticRenderFns } from "./ArtworkHistory.vue?vue&type=template&id=aca5a606&scoped=true"
import script from "./ArtworkHistory.vue?vue&type=script&lang=js"
export * from "./ArtworkHistory.vue?vue&type=script&lang=js"
import style0 from "./ArtworkHistory.vue?vue&type=style&index=0&id=aca5a606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca5a606",
  null
  
)

export default component.exports